var Payment = xClass("VivoQuickgamePayment")
Payment.prototype.ctor = function () {

}

Payment.prototype.errCodeToMsg = function (errCode) {
    //TODO:vivom没有错误码说明文档，暂时统一返回支付失败提示
    let msg = "支付失败";
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == 0){//取消支付
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[####]call vivo pay id:"+data.productId)
    let productId = data.productId
    let hasPayResult = false

    function onSuccess(resp) {
        let data = resp.data
        console.log("[################]getinfohttp success")
       let orderId = data.orderId;
        let balance = data.balance
        let cash = data.cash
        console.log("[#############]vivo pay data "+ JSON.stringify(data))
        let payment = {
            offerId:data.orderInfo,//data.orderInfo
            success: function(){
                console.log("#### vivo pay success")
                hasPayResult = true
                if (successCallback)
                    successCallback({ orderId })
            },
            fail: function (erromsg, errorcode) {
                console.log("#### vivo pay fail")
                hasPayResult = true
                let fail_type = self.getFailType(errorcode);
                failCallback({
                    code: errorcode,
                    data: self.errCodeToMsg(errorcode),
                    msg: self.errCodeToMsg(errorcode),
                    type: fail_type,//1代表是第三方掉起支付失败

                })
            },
            complete:function(){
                if (!hasPayResult){
                    console.log("#### vivo pay complete")
                    failCallback({
                        code: 0,
                        data: "初始化订单取消",
                        msg: "初始化订单取消"
                    })
                }
            }
        }
        mini.requestMidasPayment(payment)
    }

    function onFail(evt) {
        cc.log("[################]getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[################]getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }

    let http = VivoQuickgamePaymentGetInfoHttp.new(true)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.addEventListener(Events.kCancel, onCancel)
    http.load({
        productId:productId,
        openid: META.tokenid,
        zoneId: META.user.serverid,
        sessionid: META.user.sessionid,
        serverId: META.user.serverid,
        ext: data.ext

    })
}

module.exports = Payment